import { WorkflowProcessType } from '@app-store'
import { caseCancelOrVoidApi } from '../../../apis/caseStatus.api'
import {
  editEntityDataEmbeddedAPI,
  getEntityDataByIdEmbedded,
} from '../../../apis/entityData.api'
import { FIELD_NAMES } from '../../../utils/constants'
import { STRINGS } from '../../../utils/strings'

export interface CloseDuplicateWorkflowCaseParams {
  workflowInstanceId?: string
  caseId?: string | number
  workflowDefinition?: WorkflowProcessType | null
  process?: string
}

export const closeDuplicateWorkflowCase = async ({
  workflowInstanceId,
  caseId,
  workflowDefinition,
  process = STRINGS.SUSPEND,
}: CloseDuplicateWorkflowCaseParams) => {
  await caseCancelOrVoidApi(workflowInstanceId, process)

  const response = await getEntityDataByIdEmbedded(
    workflowDefinition?.global_variables?.entity_name ?? '',
    Number(workflowDefinition?.global_variables?.entity_id),
    [FIELD_NAMES.CASE_COMPLETION_DATE],
    Number(caseId)
  )

  if (!response?.data?.[FIELD_NAMES.CASE_COMPLETION_DATE]) {
    await editEntityDataEmbeddedAPI(
      workflowDefinition?.global_variables?.entity_name ?? '',
      Number(caseId),
      { [FIELD_NAMES.CASE_COMPLETION_DATE]: new Date().toISOString() },
      [FIELD_NAMES.CASE_COMPLETION_DATE]
    )
  }
}
